var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('virtual-list',{ref:"tree",attrs:{"height":_vm.height,"listData":_vm.localListData,"keygen":_vm.options.keygen,"childKey":_vm.options.childKey,"renderTitle":_vm.options.renderTitle,"emptyText":_vm.emptyText,"timeout":_vm.options.timeout,"renderItem":_vm.options.renderItem,"treeOpt":{
      mode: _vm.mode,
      checked: _vm.localValue,
      showCheckbox: _vm.showCheckbox,
      line: _vm.options.line,
      treeRender: _vm.options.treeRender,
      checkedKey: _vm.options.checkedKey || 'checked'
    }},on:{"on-check-change":_vm.checkChange,"on-query-cbk":_vm.queryCbk}})}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/FcComponents/treeV/treeV.vue